import React, { useState, useEffect } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import axios from 'axios';
import { API } from '../App';
import { Button } from '../components/ui/button';

const VerifyEmailPage = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  
  const [status, setStatus] = useState('loading'); // loading, success, error

  useEffect(() => {
    if (!token) {
      setStatus('error');
      return;
    }
    
    const verifyEmail = async () => {
      try {
        await axios.post(`${API}/auth/verify-email`, { token });
        setStatus('success');
      } catch (error) {
        setStatus('error');
      }
    };
    
    verifyEmail();
  }, [token]);

  return (
    <div className="min-h-screen bg-misel-bg flex items-center justify-center p-8">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="text-center max-w-md"
      >
        {status === 'loading' && (
          <>
            <Loader2 size={64} className="text-primary mx-auto mb-6 animate-spin" />
            <h1 className="font-roboto font-bold text-2xl text-white mb-4">
              {i18n.language === 'el' ? 'Επιβεβαίωση Email...' : 'Verifying Email...'}
            </h1>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle size={64} className="text-green-500 mx-auto mb-6" />
            <h1 className="font-roboto font-bold text-2xl text-white mb-4">
              {i18n.language === 'el' ? 'Email Επιβεβαιώθηκε!' : 'Email Verified!'}
            </h1>
            <p className="text-gray-400 mb-8">
              {i18n.language === 'el'
                ? 'Το email σου έχει επιβεβαιωθεί με επιτυχία. Μπορείς τώρα να συνεχίσεις.'
                : 'Your email has been verified successfully. You can now continue.'
              }
            </p>
            <Link to="/">
              <Button className="bg-primary hover:bg-primary/90">
                {i18n.language === 'el' ? 'Συνέχεια' : 'Continue'}
              </Button>
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle size={64} className="text-red-500 mx-auto mb-6" />
            <h1 className="font-roboto font-bold text-2xl text-white mb-4">
              {i18n.language === 'el' ? 'Σφάλμα Επιβεβαίωσης' : 'Verification Failed'}
            </h1>
            <p className="text-gray-400 mb-8">
              {i18n.language === 'el'
                ? 'Ο σύνδεσμος είναι μη έγκυρος ή έχει λήξει. Παρακαλώ ζητήστε νέο σύνδεσμο.'
                : 'The link is invalid or has expired. Please request a new verification link.'
              }
            </p>
            <Link to="/profile">
              <Button className="bg-primary hover:bg-primary/90">
                {i18n.language === 'el' ? 'Προφίλ' : 'Go to Profile'}
              </Button>
            </Link>
          </>
        )}
      </motion.div>
    </div>
  );
};

export default VerifyEmailPage;
